<template>
	<div :class="containerClass">
		<div class="formGroup" :class="{ withIcon: hasIcon, inverted: invert }">
			<slot v-if="invert"></slot>
			<label v-if="label" class="textGrey">{{ label }}</label>
			<slot v-if="!invert"></slot>
			<span v-if="hasIcon" class="fa-light" :class="iconClass"></span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: String,
		containerClass: {
			type: String
		},
		hasIcon: Boolean,
		iconClass: String,
		invert: Boolean
	}
}
</script>
